/** The fence that opens and closes a front-matter block. */
const FENCE = '---';

/**
 * An item's text without the front matter that names it.
 *
 * The drawer already shows the name and the description; repeating them as raw
 * YAML at the top of the preview would be the first thing a reader sees and the
 * least useful (spec 105 FR-023).
 *
 * Deliberately not a parser. What is above the second fence is the service's
 * business — it is what the catalog read to build the item's name — and this
 * only has to find where it ends. Anything that does not start with a fence, or
 * never closes one, is returned untouched: a file with no front matter is a
 * perfectly good file, and a malformed one is better shown whole than silently
 * truncated.
 */
export function withoutFrontMatter(text: string): string {
  if (!text.startsWith(FENCE)) return text;
  const close = text.indexOf(`\n${FENCE}`, FENCE.length);
  if (close === -1) return text;
  const after = text.indexOf('\n', close + 1 + FENCE.length);
  return after === -1 ? '' : text.slice(after + 1).replace(/^\n+/, '');
}
